// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1PMBR","name":"ConsentHeader_name__gua28","birthday":"ConsentHeader_birthday__3TYew","skeleton":"ConsentHeader_skeleton__3G7YL"};